module.exports = __webpack_public_path__ + "static/media/step-indicator-2.d5bb31f8.svg";